import type { IconProps } from '@/components/CustomIcon/types';

export const MessageIcon = ({ size = 18, className, ...props }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M3.33333 15L1.41667 16.9167C1.15278 17.1806 0.850557 17.2397 0.510001 17.0942C0.169446 16.9486 -0.000554198 16.6881 1.35722e-06 16.3125V3.33333C1.35722e-06 2.875 0.163335 2.48278 0.490001 2.15667C0.816668 1.83056 1.20889 1.66722 1.66667 1.66667H9.16667C9.40278 1.66667 9.60083 1.74667 9.76083 1.90667C9.92083 2.06667 10.0006 2.26444 10 2.5C9.99945 2.73556 9.91945 2.93361 9.76 3.09417C9.60056 3.25472 9.40278 3.33444 9.16667 3.33333H1.66667V14.2708L2.625 13.3333H15V7.5C15 7.26389 15.08 7.06611 15.24 6.90667C15.4 6.74722 15.5978 6.66722 15.8333 6.66667C16.0689 6.66611 16.2669 6.74611 16.4275 6.90667C16.5881 7.06722 16.6678 7.265 16.6667 7.5V13.3333C16.6667 13.7917 16.5036 14.1842 16.1775 14.5108C15.8514 14.8375 15.4589 15.0006 15 15H3.33333ZM14.1667 5C13.4722 5 12.8819 4.75694 12.3958 4.27083C11.9097 3.78472 11.6667 3.19444 11.6667 2.5C11.6667 1.80556 11.9097 1.21528 12.3958 0.729167C12.8819 0.243056 13.4722 0 14.1667 0C14.8611 0 15.4514 0.243056 15.9375 0.729167C16.4236 1.21528 16.6667 1.80556 16.6667 2.5C16.6667 3.19444 16.4236 3.78472 15.9375 4.27083C15.4514 4.75694 14.8611 5 14.1667 5Z"
        fill="currentColor"
      />
    </svg>
  );
};
